<div class="map-legend-item">
  <div class="legend-header-row">
    <wlm-icon class="vertical-center-icon drag-icon" [icon]="'drag_and_drops'"></wlm-icon>
        <h3 class="name">{{ mapLegendItem?.name }} ({{ mapLegendItem?.uom }})</h3>
  </div>
  <div class="item-info" *ngFor="let item of mapLegendItem?.items">
    <ng-container *ngIf="isLayerPolygon">
      <span class="polygon" [style.background]="item.color"></span>
    </ng-container>
    <ng-container *ngIf="isLayerLine">
      <span class="line" [style.background]="item.color"></span>
    </ng-container>
    <ng-container *ngIf="!isLayerLine && !isLayerPolygon">
      <span class="svg-shape" *ngIf="item.iconPath" [innerHTML]="item.iconPath"></span>
    </ng-container>
    <span class="legend-range">{{ item.rangeDefinition }}</span>
  </div>
</div>
